export const state = () => ({
  // 当前语种
  lang: 'en-US'
})

export const mutations = {
  getCurLang(state, lang) {
    state.lang = lang
  }
}
